import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { WarehouseService } from 'src/app/api/config/warehouse.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import SwalAlert from 'src/app/utils/swalalert';
import AlertifyHelper from 'src/app/utils/utils';


@Component({
  selector: 'app-stockgeneral-list',
  templateUrl: './stockgeneral-list.component.html',
  styleUrls: ['./stockgeneral-list.component.css']
})
export class StockgeneralListComponent implements OnInit {
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables
  warehouses: any = [];
  warehouseSelected:any = 1

  constructor(
    private warehouseService: WarehouseService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
  }

  ngOnInit() {
    this.getWarehouses();
    this.list();
  }

  getWarehouses() {
    this.warehouseService.listWarehouseBranchoffice().subscribe({
      next: (data: any) => {
        this.warehouses = data.results;
        this.warehouseSelected = this.warehouses[0].id;
      }
    });
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page+ '&warehouse=' + this.warehouseSelected;
    this.warehouseService.listStockGeneral(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
    // setTimeout(() => {
    // }, 500);
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  changeWarehouseSelected(){
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

}
